import React from 'react';
import { useGlobalValue } from '../../../state/GlobalProvider';
import styles from './HeaderMessage.module.sass';

const HeaderMessage = props => {
  const {
    headerMessage
  } = props;
  const {
    className,
    message
  } = headerMessage;
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles['message']} ${styles[className || '']}`
  }, /*#__PURE__*/React.createElement("p", null, i18n`${message}`));
};

export default HeaderMessage;